import { catchError, debounceTime, from, map, mergeMap, of } from "rxjs"
import { combineEpics, ofType } from "redux-observable"
import {
    fetchSerialNumberListingError,
    fetchSerialNumberListingSuccess,
    SERIAL_NUMBER_ACTION_TYPES
} from "../actions"
import { SerialNumberListingService } from "../service"

const fetchAvailableSerialNumberListingEpic = (action$) => action$.pipe(
    ofType(SERIAL_NUMBER_ACTION_TYPES.FETCH_SERIAL_NUMBER_LISTING),
    debounceTime(500),
    mergeMap(({payload}) => {
        return from(SerialNumberListingService.findAvailableByProductId(payload))
            .pipe(
                map(fetchSerialNumberListingSuccess),
                catchError(err => of(fetchSerialNumberListingError(err.message)))
            )
    }),
)

export const serialNumberListingEpics = combineEpics(fetchAvailableSerialNumberListingEpic)


// WEBPACK FOOTER //
// ./src/state/listing/serial-numbers/epics/epics.ts